import { createSelector } from 'reselect';
import { FLAGS } from '@commons/fwf/constants';
import { MODULE_NAME } from './constants';

const getPropFromModule = (state, ...props) =>
  state.getIn([MODULE_NAME, ...props]);

export const getAllFlags = createSelector(
  state => getPropFromModule(state, 'flags'),
  flags => flags?.toJS(),
);

export const getFlagFromState = (state, flagName) => {
  const flags = getAllFlags(state);
  if (!flags) return null;
  return flags[flagName];
};

export const getShowNativeModalFlag = createSelector(
  state => getFlagFromState(state, FLAGS.WEB_TO_NATIVE_CHECKOUT.KEY),
  flag => flag?.variation !== false,
);
